// extracted by mini-css-extract-plugin
export default {"hoverBlue":"#43a8e1","chipBlue":"#dcebfe","chipLabelBlue":"#52749f"};